export const setSearchData = (data) => {

  return {
  		type: 'SEARCHDATA',
  		dataForSearch: data
  	}
}

export const setFullSearchData = (component) => {
	return {
		type: 'SET_FULL_SEARCH_DATA',
		payload: component
	}
}



// WEBPACK FOOTER //
// ./src/redux/actions/searchAction.js